// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    Object: 'value',
    label: '',
    width: '120'
  }, {
    prop: 'status',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'supplier',
    Object: 'value',
    label: '',
    width: '150'
  }, {
    prop: 'quantity',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'remarks',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'created_at',
    label: '',
    Object: 'value',
    width: '120'
  }]
}
